import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import SidebarNavigation from "./SidebarNavigation"

const SidebarNavigationPhases = ({
  currentPageId,
  alwaysOpen,
  languageCode,
}) => {
  const { allWpPage } = useStaticQuery(graphql`
    query PatientPhaseChildPagesByParentIdAndTemplate {
      allWpPage(
        filter: {
          parentId: { eq: "cG9zdDo1OQ==" }
          template: { templateName: { eq: "Phase" } }
        }
        sort: { menuOrder: ASC }
      ) {
        edges {
          page: node {
            title
            id
            uri
            customFields {
              navigationTitle
            }
            translations {
              title
              id
              uri
              customFields {
                navigationTitle
              }
            }
          }
        }
      }
    }
  `)

  return (
    <SidebarNavigation
      pages={allWpPage.edges}
      currentPageId={currentPageId}
      title={
        languageCode === "es" ? "El Viaje Del Embarazo" : "Pregnancy Journey"
      }
      alwaysOpen={alwaysOpen}
      languageCode={languageCode}
    />
  )
}

export default SidebarNavigationPhases
